export default "<div class=\"card-list\" ng-transclude>\n</div>"